import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import { Link } from "@tanstack/react-router"

function NotFoundPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        gap: 2,
        textAlign: "center",
        px: 4
      }}
    >
      <Typography variant="h4" color="primary">
        404 Page not found
      </Typography>
      <Typography variant="body1" color="text.secondary">
        The page you&apos;re looking for doesn&apos;t exist or has moved.
      </Typography>
      <Button variant="contained" component={Link} to="/" sx={{ mt: 1 }}>
        Go home
      </Button>
    </Box>
  )
}

export default NotFoundPage
